import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/kk';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';

dayjs.extend(utc);
dayjs.extend(updateLocale);

// Customize Kazakh locale globally
dayjs.updateLocale('kk', {
    monthsShort: [
        'Қаң',
        'Ақп',
        'Нау',
        'Сәу',
        'Мам',
        'Мау',
        'Шіл',
        'Там',
        'Қыр',
        'Қаз',
        'Қар',
        'Жел',
    ],
    monthFormat: 'MMM',
});

// Customize Russian locale
dayjs.updateLocale('ru', {
    monthsShort: [
        'Янв',
        'Фев',
        'Мар',
        'Апр',
        'Май',
        'Июн',
        'Июл',
        'Авг',
        'Сен',
        'Окт',
        'Ноя',
        'Дек',
    ],
});

// Customize English locale
dayjs.updateLocale('en', {
    monthsShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ],
});

export default dayjs;
